import { render, staticRenderFns } from "./data-sources.vue?vue&type=template&id=47c29032&scoped=true"
import script from "./data-sources.vue?vue&type=script&lang=js"
export * from "./data-sources.vue?vue&type=script&lang=js"
import style0 from "./data-sources.vue?vue&type=style&index=0&id=47c29032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c29032",
  null
  
)

export default component.exports